var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 52,
    viewBox: "0 0 49 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xC3\x8Dcone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.8756 20.6437V11.0809C32.8756 10.4508 32.6338 9.85778 32.1875 9.41299L24.9909 2.25941L3.43808 9.63538C2.48969 9.96897 1.85742 10.8585 1.85742 11.8593V48.109C1.85742 49.4249 2.91739 50.4812 4.23771 50.4812H45.6324C46.4693 50.4812 47.1387 49.814 47.1387 48.9801V43.9207C47.1387 41.3632 45.0746 39.3061 42.5083 39.3061C39.9421 39.3061 37.8779 41.3632 37.8779 43.9207V50.4812",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.9004 50.4998V2.25941",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.40039 50.4997V43.9392C7.40039 43.272 7.84669 42.679 8.49755 42.4937L12.1052 41.5114L15.9546 40.4551C16.3823 40.3439 16.81 40.6589 16.81 41.1037V50.4997",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.1035 50.5001V41.5118",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.45703 14.0277L24.9001 8.20842",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M7.45703 19.6244L24.9001 13.8051",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M7.45703 25.1661L24.9001 19.3469",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M7.45703 30.7445L24.9001 24.9253",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M13.9453 34.1353L24.8984 30.4843",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M7.45703 36.3044L10.2836 35.3592",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M7.45703 8.20868V3.16781C7.45703 2.24118 8.20087 1.49988 9.13067 1.49988C10.0605 1.49988 10.8043 2.24118 10.8043 3.16781V7.11525",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M24.9004 45.4958H47.1412",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M24.9004 24.2024H39.2937C40.2793 24.2024 41.0789 24.9993 41.0789 25.9815V39.5474",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M36.3552 27.6671H29.3817C28.9196 27.6671 28.5449 28.0405 28.5449 28.5011V29.7799C28.5449 30.2404 28.9196 30.6138 29.3817 30.6138H36.3552C36.8174 30.6138 37.1921 30.2404 37.1921 29.7799V28.5011C37.1921 28.0405 36.8174 27.6671 36.3552 27.6671Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M36.3552 33.5612H29.3817C28.9196 33.5612 28.5449 33.9345 28.5449 34.3951V35.6739C28.5449 36.1345 28.9196 36.5078 29.3817 36.5078H36.3552C36.8174 36.5078 37.1921 36.1345 37.1921 35.6739V34.3951C37.1921 33.9345 36.8174 33.5612 36.3552 33.5612Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M31.3343 39.5468H29.3817C28.9196 39.5468 28.5449 39.9202 28.5449 40.3808V41.6595C28.5449 42.1201 28.9196 42.4935 29.3817 42.4935H31.3343C31.7965 42.4935 32.1711 42.1201 32.1711 41.6595V40.3808C32.1711 39.9202 31.7965 39.5468 31.3343 39.5468Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/Building.bf4ca1707981e59833169d603c7bc573.svg";
export { ForwardRef as ReactComponent };